<script>
export default {
  components: {
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['validationResponse', 'selectedMethod', 'csvFile'],
  data: vm => ({
    loading: false,
    validationRules: [
      value => {
        return !value || !value.length || value[0].size < 50000000
          || vm.$t('component.profile.administrationManagement.csv.upload.validation.rule.error')
      }
    ],
    alert: {
      state: false,
      type: 'error',
      message: vm.$t('global.error')
    }
  }),
  computed: {
    validationResponseHasErrors() {
      return this.validationResponse && this.validationResponse.some(item => item.message !== 'OK')
    }
  },
  methods: {
    sendCSV() {
      this.loading = true

      let formData = new FormData()
      formData.append('file', this.csvFile)
      formData.append('envUrl', `${window.config.VUE_APP_BASE_URL}`)

      this.$organizationService
        .importCSV(formData)
        .then(() => {
          this.$emit('finish-wizard')
          this.$emit('close-dialog')
        })
        .catch((e) => {
          console.error('error sending csv', e)
          this.$emit('alert-error', e)
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>
<template>
  <v-stepper-content step="3">
    <v-card-text>
      <div
        v-if="!validationResponse"
        class="text-center mb-5 mt-5">
        <v-progress-circular
          size="50"
          indeterminate></v-progress-circular>
        <br>
        <br>
        {{ $t('component.profile.administrationManagement.validating') }}
      </div>
      <div
        v-if="validationResponse && selectedMethod === 'csv'"
        class="table-responsive mt-5 mb-5">
        <table class="table">
          <thead>
          <tr class="tex">
            <th>{{ $t('global.line') }}</th>
            <th>{{ $t('global.name') }}</th>
            <th>{{ $t('global.email') }}</th>
            <th>{{ $t('global.status') }}</th>
          </tr>
          </thead>
          <tbody v-for="(item, index) in validationResponse" :key="index">
          <tr>
            <td :class="{ 'invitation-validation-response-error': item.message !== 'OK' }">
              #{{ item.line }}
            </td>
            <td :class="{ 'invitation-validation-response-error': item.message !== 'OK' }">
              {{ item.entry.firstName }} {{ item.entry.lastName }}
            </td>
            <td :class="{ 'invitation-validation-response-error': item.message !== 'OK' }">
              {{ item.entry.email }}
            </td>
            <td>
              <v-icon
                v-if="item.message === 'OK'"
                color="success">mdi-check-circle
              </v-icon>
              <span v-else>
                <small class="red--text"> {{ item.message }} </small>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        id="em_close_button"
        color="secondary"
        class="white--text px-8 py-2"
        @click="$emit('step-back')">
        <span>
          {{ $t('button.back') }}
        </span>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if="selectedMethod === 'csv'"
        id="em_csv_check_button"
        :disabled="!csvFile && !validationResponseHasErrors"
        color="primary"
        :loading="loading"
        class="white--text px-8 py-2"
        @click="sendCSV">
        <span v-if="validationResponseHasErrors">
         {{ $t('button.import.anyway') }}
        </span>
        <span v-else>
          {{ $t('button.import') }}
        </span>
      </v-btn>
    </v-card-actions>
  </v-stepper-content>
</template>
<style scoped>
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.invitation-validation-response-error {
  text-decoration: line-through;
  color: red;
}
</style>
